import { matchPath } from 'react-router-dom';
import urls from 'Source/urls';

export const isCorrelationRulesRoute = (url: string): boolean =>
  url.includes(urls.build.detections.correlationRules.list());

export const isSimpleDetectionFormRoute = (url: string): boolean =>
  url.includes(urls.build.detections.rules.list()) ||
  url.includes(urls.build.detections.policies.list()) ||
  url.includes(urls.build.detections.create());

export const isAIRoute = (pathname: string): boolean => {
  return matchPath(pathname, urls.ai.home()) !== null;
};

// The Scheduled Prompts list is an AI feature but renders as a standard list page
// (shared header + default width), unlike the full-bleed AI chat surfaces.
export const isScheduledPromptsListRoute = (pathname: string): boolean =>
  matchPath(pathname, { path: urls.ai.scheduledPrompts.list(), exact: true }) !== null;

// AI surfaces render full-bleed (MAX width, no shared header); the Scheduled Prompts
// list is the exception. Single source of truth for both the width and header hooks.
export const isFullBleedAIRoute = (pathname: string): boolean =>
  isAIRoute(pathname) && !isScheduledPromptsListRoute(pathname);

export const isWorkbenchRoute = (url: string): boolean =>
  url.includes(urls.contentCatalog.workbench());

export enum PageWidthSize {
  MAX = 'max', // 3840px, no margins (flush to edge)
  XL = 'xl', // 3840px, with 32px margins
} // 1760px is the default

export const useGetPageWidth = (): PageWidthSize | null => {
  const pageURL = window.location.href;
  const { pathname } = window.location;

  if (
    isCorrelationRulesRoute(pageURL) ||
    isSimpleDetectionFormRoute(pageURL) ||
    isFullBleedAIRoute(pathname) ||
    isWorkbenchRoute(pageURL)
  ) {
    return PageWidthSize.MAX;
  }

  if (
    [
      urls.investigate.search(),
      urls.investigate.dataExplorer(),
      urls.investigate.searchHistory(),
      urls.configure.logSources.home(),
      urls.configure.enrichmentProviders.home(),
      urls.configure.cloudAccounts.home(),
      urls.configure.alertDestinations.home(),
      urls.build.detections.home(),
      urls.build.dataModels.list(),
    ].some(url => pageURL.includes(url))
  ) {
    return PageWidthSize.XL;
  }

  return null;
};
